package com.klantenstop.web.data.models.domain

import com.klantenstop.web.data.models.dto.responses.ReviewDto
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toJSDate

data class Review(
    val id: String,
    val user: User? = null,
    val text: String = "",
    val rating: Int = 0,
    val createdAt: Instant,
    val updatedAt: Instant
) {
    val createdAtHumanReadable get() = run {
        val localeOptions = dateLocaleOptions {
            day = "numeric"
            month = "numeric"
            year = "numeric"
        }

        return@run createdAt.toJSDate().toLocaleString("be", localeOptions)
    }

}

fun ReviewDto.toReview() = Review(
    id = this.id,
    user = this.user?.toUser(),
    text = this.text,
    rating = this.rating,
    createdAt = LocalDateTime.parse(createdAt).toInstant(TimeZone.UTC),
    updatedAt = LocalDateTime.parse(updatedAt).toInstant(TimeZone.UTC)
)
